import styled from '@emotion/styled'
import { Icon } from '@mui/material'
import theme from 'lib/theme'
import { ElementType } from 'react'

export const SlotIcon = styled(Icon, {
  shouldForwardProp: (props) => props !== 'inThePast',
})<{ inThePast: boolean; component: ElementType }>(({ inThePast }) => ({
  fill: inThePast ? theme.palette.text.primary : theme.palette.primary.main,
  height: theme.spacing(2),
  width: theme.spacing(2),
  marginRight: '2px',
  '*': {
    fill: inThePast ? '' : theme.palette.primary.main,
  },
  '&:hover': {
    fill: inThePast ? theme.palette.text.primary : theme.palette.primary.main,
  },
}))
